import * as t from 'io-ts';

import {makeApiType, makeEnumRuntimeType} from './apiTypes';

/*
 * Constants.
 */

export enum SalesforceFieldTypesEnum {
  ADDRESS = 'address',
  BOOLEAN = 'boolean',
  COMBOBOX = 'combobox',
  CURRENCY = 'currency',
  DATE = 'date',
  DATETIME = 'datetime',
  DOUBLE = 'double',
  EMAIL = 'email',
  ID = 'id',
  INT = 'int',
  LOCATION = 'location',
  MULTI_PICKLIST = 'multipicklist',
  PERCENT = 'percent',
  PHONE = 'phone',
  PICKLIST = 'picklist',
  REFERENCE_USER = 'referenceuser',
  STRING = 'string',
  TEXTAREA = 'textarea',
  TIME = 'time',
  URL = 'url',
}

/*
 * Runtime type.
 */

const RCrmSalesforceFieldDirty = t.readonly(
  t.type({
    id: t.string,
    label: t.string,
    type: makeEnumRuntimeType(SalesforceFieldTypesEnum),
  }),
);

/*
 * Type.
 */

export interface CrmSalesforceFieldModel extends t.TypeOf<typeof RCrmSalesforceFieldDirty> {}
export const RCrmSalesforceField = t.clean<CrmSalesforceFieldModel>(RCrmSalesforceFieldDirty as any);
export const RCrmSalesforceFields = t.readonlyArray(RCrmSalesforceField);

/*
 * IO methods.
 */

export function parseCrmSalesforceField(src: any) {
  return {
    id: src.name,
    label: src.label,
    type: src.type,
  };
}

export function parseCrmSalesforceFields(src: any): ReadonlyArray<CrmSalesforceFieldModel> {
  return src.map(parseCrmSalesforceField);
}

/*
 * API type.
 */

export const ApiCrmSalesforceField = makeApiType(
  'crmSalesforceField',
  RCrmSalesforceField,
  parseCrmSalesforceField,
);
export const ApiCrmSalesforceFields = makeApiType(
  'crmSalesforceFields',
  RCrmSalesforceFields,
  parseCrmSalesforceFields,
);
